import getKeyFromMonthly from './getKeyFromMonthly'

function getPremium(plan: Plan, defaultValue = 0): number {
  return getKeyFromMonthly('premium', plan, defaultValue)
}

export default getPremium
